<div class="no-compliance-tile">
  <a href="https://anzcofoods.com/contact-us/livestock-reps/" target="_blank" data-cy="noComplianceCard">
    <mat-card>
      <div>
        <img src="../../../assets/images/nzfai_big.jpg" alt="nzfap image" />
        <div>
          <span>Your property is not NZFAP certified</span>
        </div>
      </div>
      <span class="blue-text">Click here to find out more</span>
    </mat-card>
  </a>
</div>